<template>
	<TicketIcon class="w-6 h-6 transform rotate-90" />
</template>

<script setup lang="ts">
import { TicketIcon } from '@heroicons/vue/24/outline'
</script>
